/**
 * This is the list of hosts/publishers that are blocked
 * from using Vuukle Widgets.
 */

export default [
  '8ccda731-6ed4-4965-a6e9-e05ae318389d',
  '06bbd0e5-c863-4bd4-a24f-65cbbb6ebf90',
  'fb7adc50-1895-4260-ae4e-d958e0943e86',
  '3a576486-18b5-4438-b12f-340af1d2a0e0',
  '8c6794b5-f7fd-4cd1-a038-a8d1b5f6a758',
  '96bf641a-66d8-11e5-9bc9-002590f371ee',
  '10d0bfe0-3737-4481-80ab-d837492181de',
  '46059264-25f1-4b76-a88b-6d1c75c66f42',
  '55971aa3-e05a-49d3-b2e9-83243ce15cc4',
  'ae9bb8a3-d291-4ba3-9172-1f02e37aaff3',
  'b1714e6a-1ebd-42a7-8149-91c7949ffa3c',
  '6c9faada-99c9-4675-a276-ea1e17165a25',
  '3368388b-0a3d-45da-a382-6fb1019db01b',
  'c0b2fe99-a42f-4deb-b87f-53acab8905a0',
  '2efc88c2-1141-4a6a-90d9-7e47f4476335',
  '3779bc94-f3ce-4138-af5d-1d3c0d7ee3b8',
  '3f9039a9-057a-4853-a545-0a9d334060a7',
  '1826a8a1-7b9f-464b-8308-004d8fa65dd1',
  'c960b925-0318-448d-b341-2990d904066a',
  '8543c083-0a45-4c77-adfc-07ffa2a1723b',
  'dee74ed8-c77d-45c9-a24b-6d0f14ba48d4'
];
